export default __webpack_public_path__ + "static/media/right-arrow-alt.72d7ccb4.svg";